import { render } from "./side-map.vue?vue&type=template&id=3f74317f&scoped=true"
import script from "./side-map.vue?vue&type=script&lang=js"
export * from "./side-map.vue?vue&type=script&lang=js"

import "./side-map.vue?vue&type=style&index=0&id=3f74317f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f74317f"]])

export default __exports__